import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsWaterNormalXsmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g clipPath="url(#sports_water_normal_xsmall_svg__clip0_138_646)">
        <path
          d="M8 13.5a2.82 2.82 0 01-2.51-1.51h-1a2.823 2.823 0 01-2.5 1.51A2.779 2.779 0 010 12.69v1.26a3.743 3.743 0 001.99.55 3.822 3.822 0 003-1.45A3.8 3.8 0 008 14.5a3.742 3.742 0 003-1.46v-1.05h-.5A2.793 2.793 0 018 13.5zm3.51-6.51H10.5a2.833 2.833 0 01-5 0H4.49a2.8 2.8 0 01-2.5 1.5A2.813 2.813 0 010 7.69v1.25a3.743 3.743 0 001.99.55 3.762 3.762 0 003-1.45 3.849 3.849 0 006.02 0 3.845 3.845 0 004.99.9V7.69a2.85 2.85 0 01-4.49-.7zM11.52 2h-1.03A2.787 2.787 0 018 3.5 2.814 2.814 0 015.5 2H5v1.05a3.839 3.839 0 006.01 0 3.762 3.762 0 003 1.45A3.743 3.743 0 0016 3.95V2.69a2.78 2.78 0 01-1.99.81A2.8 2.8 0 0111.52 2z"
          fill=""
        />
      </g>
      <defs>
        <clipPath id="sports_water_normal_xsmall_svg__clip0_138_646">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  )
);
SvgSportsWaterNormalXsmall.defaultProps = {
  color: 'currentColor',
  size: 16,
  title: undefined,
  titleId: undefined
};
SvgSportsWaterNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsWaterNormalXsmall;
